/* eslint-disable no-unused-vars */
import { Text6, Text3, Text2, EmptyState, RowList, Row, skinVars, IconListRegular } from '@telefonica/mistica';
import React, { useState } from 'react';
import './index.scss';
import { t } from 'i18next';
import DetailConsumptionDataList from './Data';
import DetailConsumptionVoice from './Voice';
import DetailConsumptionSMS from './SMS';

export interface DetailConsumptionData {
    activeView: string;
    page: any;
}

export const DetailConsumption: React.FC<DetailConsumptionData> = ({
    activeView = 'VOICE',
    page,
}: DetailConsumptionData) => {
    const [gastoExtra] = useState(0);

    return (
        <div className='DetailConsumption'>
            {activeView === 'DATA' && <DetailConsumptionDataList />}
            {activeView === 'VOICE' && <DetailConsumptionVoice />}
            {activeView === 'SMS' && <DetailConsumptionSMS />}
            {activeView === 'Otros' &&
                (gastoExtra > 0 ? (
                    <RowList>
                        <Row
                            title=''
                            asset={''}
                            right={
                                <div>
                                    <Text6
                                        color={gastoExtra > 0 ? skinVars.colors.errorHigh : skinVars.colors.textPrimary}
                                    >
                                        {gastoExtra} €
                                    </Text6>
                                </div>
                            }
                            headline={
                                <div className='DetailConsumption__row-headline'>
                                    <div className='DetailConsumption__row-headline-consumption'>
                                        <div>
                                            <Text3 regular>607 25 22 13</Text3>
                                        </div>
                                    </div>
                                </div>
                            }
                            extra={
                                <div>
                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                        15:45 - SMS
                                    </Text2>
                                </div>
                            }
                        ></Row>
                    </RowList>
                ) : (
                    <div className='DetailConsumption__emptyState'>
                        <EmptyState
                            asset={<IconListRegular color={skinVars.colors.brand} size={64} />}
                            title={t('titleOtherDetails')}
                            description={t('descriptionOtherDetails')}
                        ></EmptyState>
                    </div>
                ))}
        </div>
    );
};

export default DetailConsumption;
